<div class="modal is-active">
  <div class="modal-background" (click)="onCancel.emit()"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ title() }}</p>
      <button class="delete" aria-label="close" (click)="onCancel.emit()"></button>
    </header>
    <section class="modal-card-body">
      <p>{{ message() }}</p>
      @if (details()) {
        <p class="has-text-weight-semibold mt-3">{{ details() }}</p>
      }
    </section>
    <footer class="modal-card-foot">
      <button class="button is-danger" (click)="onConfirm.emit()" [disabled]="loading()">
        @if (loading()) {
          <span class="loader"></span>
        }
        {{ confirmText() }}
      </button>
      <button class="button" (click)="onCancel.emit()" [disabled]="loading()">
        {{ cancelText() }}
      </button>
    </footer>
  </div>
</div>
